
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorPistonInleftBottom75 as ObiThreewayAcuatorPistonInleftBottom75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-piston-inleft-bottom-75.js';
 
 
 

 
 export const ObiThreewayAcuatorPistonInleftBottom75 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-piston-inleft-bottom-75',
   elementClass: ObiThreewayAcuatorPistonInleftBottom75Element,
   events: {
     
   }
  });
 
 